import {
  mdiAccountCircle,
  mdiBellOutline,
  mdiChevronDown,
  mdiCogOutline,
  mdiPower,
  mdiViewDashboardOutline,
} from "@mdi/js";
import Icon from "@mdi/react";
import Cookies from "js-cookie";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { Tooltip as ReactTooltip } from "react-tooltip";
import { UseContextData } from "../../context/dateContext";
import ToggleSwitch from "../switch/ToggleSwitch";
import { useTranslation } from "react-i18next";
import { NavLink } from "react-router-dom";

import overviewIcon from "../../assets/sidebar/overview.svg";
import listDevicesIcon from "../../assets/sidebar/list-of-devices.svg";
import digitalTwinIcon from "../../assets/sidebar/digital-twin.svg";
import canvasIcon from "../../assets/sidebar/canvas.svg";
import { PiUpload } from "react-icons/pi";

const Sidebar = () => {
  const [open, setOpen] = useState(true);
  const navigate = useNavigate();
  const location = useLocation();
  const { isDarkTheme, setIsDarkTheme, user, setUser } = UseContextData();
  const { t } = useTranslation();

  const handleLogout = () => {
    Cookies.remove("user");
    navigate("/login");
  };

  // const [user, setUser] = useState(null);
  useEffect(() => {
    const storedUser = Cookies.get("user");
    if (storedUser) {
      setUser(JSON.parse(storedUser));
    }
  }, []);

  const handleGoBack = () => {
    if (document.referrer && document.referrer !== window.location.href) {
      window.location.href = document.referrer;
    } else {
      window.location.href = "https://dynamoedge.com/";
    }
  };

  return (
    <div className="overflow-hidden min-h-screen w-60 lg:w-60 bg-white dark:bg-[#252525] shadow-lg z-20 p-4 pt-0  flex flex-col transition-all">
      <div className="flex-grow">
        {/* Logo */}
        <div className="flex justify-center items-center my-4 p-4">
          <img
            src="/assets/images/directv.png"
            alt="logo"
            className=" cursor-pointer"
            onClick={() => navigate("/")}
          />
        </div>

        {/* Homenet Section */}
        <div
          className="border-0 p-3 bg-[#E6F8F2] dark:bg-[#aaaaaa] rounded-lg flex items-center justify-between cursor-pointer"
          onClick={() => setOpen(!open)}
        >
          <div className="flex items-center">
            <img
              src={
                isDarkTheme
                  ? "/assets/icons/traffic-event 2.svg"
                  : "/assets/icons/traffic-event.svg"
              }
              alt="traffic-event"
              className="mr-2 w-5 h-5"
            />
            <div className="text-primary dark:text-white text-base font-bold">
              {t("Homenet")}
            </div>
          </div>
          <Icon
            path={mdiChevronDown}
            size={1}
            className={`${
              open ? "rotate-180" : ""
            } text-primary dark:text-white transition-transform`}
          />
        </div>

        {open && (
          <ul className="mt-4 ml-6 flex flex-col gap-4" id="sidebar">
            {sidebarObjects.map((link) => {
              return (
                <NavLink
                  key={link.id}
                  to={link.path}
                  className={({ isActive, isPending, isTransitioning }) =>
                    [
                      "flex items-center gap-2 rounded-md",
                      isPending ? "pending" : "",
                      isActive ? "active" : "",
                      isTransitioning ? "transitioning" : "",
                    ].join(" ")
                  }
                >
                  <span className="w-5 h-5 flex items-center justify-center text-primary">
                    {typeof link.icon === "string" ? (
                      <img src={link.icon} alt={link.label} />
                    ) : (
                      link.icon
                    )}
                  </span>
                  <span>{link.label}</span>
                </NavLink>
              );
            })}
            {/* <li
              className={`flex text-base ${
                ["/fleet_view", "/fleet_view_map", "/"].includes(
                  location.pathname
                )
                  ? "text-primary font-bold dark:text-white"
                  : "text-dark1 dark:text-[#797979]"
              } mt-4 cursor-pointer`}
              onClick={() => navigate("/fleet_view")}
            >
              <img
                src={"/assets/icons/sidebar/overview.svg"}
                alt="overview"
                className="mr-2 w-5 h-5"
              />
              {t("Overview")}
            </li>
            <li
              className={`flex text-base ${
                ["/devices_list"].includes(location.pathname)
                  ? "text-primary font-bold dark:text-white"
                  : "text-dark1 dark:text-[#797979]"
              } mt-4 cursor-pointer`}
              onClick={() => navigate("/devices_list")}
            >
              <img
                src={"/assets/icons/sidebar/list-of-devices.svg"}
                alt="list of devices"
                className="mr-2 w-5 h-5"
              />

              {t("List of devices")}
            </li>

            <li
              className={`flex gap-4 text-base ${
                ["/digital_twins"].includes(location.pathname)
                  ? "text-primary font-bold dark:text-white"
                  : "text-dark1 dark:text-[#797979]"
              } cursor-pointer`}
              onClick={() => navigate("/digital_twins")}
            >
              <img
                src={"/assets/icons/sidebar/digital-twin.svg"}
                alt="traffic-event"
              />
              {t("Digital Twin")}
            </li>
            <li
              className={`flex gap-4 text-base ${
                ["/canvas"].includes(location.pathname)
                  ? "text-primary font-bold"
                  : "text-dark1 dark:text-[#797979]"
              } cursor-pointer`}
              onClick={() => navigate("/canvas")}
            >
              <img
                src={
                  ["/canvas"].includes(location.pathname)
                    ? "/assets/icons/sidebar/canvas.svg"
                    : "/assets/icons/sidebar/canvas.svg"
                }
                alt="canvas"
              />

              {t("Canvas")}
            </li> */}
          </ul>
        )}

        {/* Canvas Section */}
      </div>

      {/* Footer Section */}

      <div className="p-4">
        <div
          className="px-4 text-base text-[#0DBF4F] flex items-center font-medium mt-4 cursor-pointer dark:text-[#797979]"
          onClick={handleGoBack}
        >
          <img
            src="/assets/icons/home_button.svg"
            alt="Home Button"
            className="mr-2"
          />
          {t("Home")}
        </div>
        <div className="px-3 text-base text-dark1 dark:text-[#797979] flex items-center mt-4 cursor-pointer">
          <Icon path={mdiBellOutline} size={1} className="mr-2" />
          {t("Notifications")}
        </div>
        <div className="px-3 text-base text-dark1 dark:text-[#797979] flex items-center mt-4 cursor-pointer">
          <Icon path={mdiViewDashboardOutline} size={1} className="mr-2" />
          {t("Module")}
        </div>
        <div className="px-3 text-base text-dark1 dark:text-[#797979] flex items-center mt-4 cursor-pointer">
          <Icon path={mdiCogOutline} size={1} className="mr-2" />
          {t("Settings")}
        </div>

        {/* User Section */}
        <div className="px-3 text-base text-dark1 dark:text-[#797979] flex justify-between items-center mt-4 cursor-pointer">
          <div className="flex items-center">
            <Icon path={mdiAccountCircle} size={1} className="mr-2" />
            {t(user?.username)}
          </div>
          <Icon
            path={mdiPower}
            size={1}
            onClick={handleLogout}
            className="text-red-600"
            data-tooltip-id="alert-msg"
          />
          <ReactTooltip
            id="alert-msg"
            place="top"
            content={<div>{t("Logout")}</div>}
          />
        </div>
      </div>
    </div>
  );
};

export default Sidebar;

const sidebarObjects = [
  { id: 0, icon: overviewIcon, label: "Overview", path: "/" },
  {
    id: 1,
    icon: listDevicesIcon,
    label: "List of Devices",
    path: "/devices_list",
  },
  {
    id: 2,
    icon: digitalTwinIcon,
    label: "Digital Twin",
    path: "/digital_twins",
  },
  { id: 3, icon: canvasIcon, label: "Canvas", path: "/canvas" },
  // { id: 4, icon: <PiUpload />, label: "Upload", path: "/upload" },
];
